import { translations as fr } from '../translations/message.fr';
import { translations as de } from '../translations/message.de';
import { translations as es } from '../translations/message.es';
import { translations as en } from '../translations/message.en';

export const messages = {
  de,
  en,
  es,
  fr,
};
  